<script lang="ts">
  import { Col, ListGroup, ListGroupItem, Row } from "sveltestrap";
  import {  Home, JavaScriptbehavior, Listdetail, listprofile, Messages, Settings} from "../../../utils/Constant/Constant";
  import Card from "../UiCommenCard.svelte";
  import {listId} from "../../../store"
    let setlistId:String
    const handlelist = (getId:string) =>{
      listId.update(value => value = getId)
    }
    listId.subscribe((value:string)=>{
        setlistId = value
    })
</script>
<Col sm="12" xl="12">
    <Card cardHeaderprops="pb-0" headerTitle={JavaScriptbehavior}>
      <div slot="contentbody">
        <Row>
            <Col sm="4">
              <ListGroup id="list-tab" role="tablist">
                <ListGroupItem active={setlistId === "list-home" ? true : false } tag="button" action id="list-home" on:click={()=>handlelist("list-home")} >{Home}
                </ListGroupItem>
                <ListGroupItem active={setlistId === "list-profile" ? true : false } id="list-profile" tag="button" action on:click={()=>handlelist("list-profile")} >{listprofile}
                </ListGroupItem>
                <ListGroupItem active={setlistId === "list-messages" ? true : false } id="list-messages" tag="button" action on:click={()=>handlelist("list-messages")} >{Messages}
                </ListGroupItem>
                <ListGroupItem active={setlistId === "list-settings" ? true : false } id="list-settings" tag="button" action on:click={()=>handlelist("list-settings")} >{Settings}
                </ListGroupItem>
              </ListGroup>
            </Col>
            <Col sm="8">
              <div class="tab-content" id="nav-tabContent">
                <div class="tab-pane fade {setlistId === "list-home" ? "show active" : "" }" id="list-home" >1{Listdetail}</div>
                <div class="tab-pane fade {setlistId === "list-profile" ? "show active" : "" }" id="list-profile">2{Listdetail}</div>
                <div class="tab-pane fade {setlistId === "list-messages" ? "show active" : "" }"  id="list-messages">3{Listdetail}</div>
                <div class="tab-pane fade {setlistId === "list-settings" ? "show active" : "" }" id="list-settings">4{Listdetail}</div>
              </div>
            </Col>
        </Row>
      </div>
    </Card>
</Col>

       
    